// extracted by mini-css-extract-plugin
module.exports = {"top-locations":"top-locations_top-locations__daqSI"};